export const DCCOST_UPLOAD_ACCEPTED_EXTENSIONS = ".xlsx,.xlsm";

export const DCCOST_UPLOAD_ACCEPTED_MIME_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel.sheet.macroEnabled.12",
];

export const DCCOST_UPLOAD_FILE_PATTERN = /\.(xlsx|xlsm)$/i;
